import { CapacityTagDto } from './CapacityTagDto';

export interface CapacityClosedFlags {
	vehicleBookingsClosed: boolean;
	passengerBookingsClosed: boolean;
	freightBookingsClosed: boolean;
}

/**
 * Determines whether a nested capacity tag (e.g. a vehicle capacity type or an add-on) should be
 * shown as closed.
 *
 * A tag is closed only when every booking type it applies to is closed. In particular, a vehicle
 * capacity type (which only applies to vehicle bookings) is closed whenever vehicle bookings are
 * closed — so nested vehicle capacities match the top-level vehicle capacity. An add-on shared with
 * a booking type that is still open stays open.
 */
export function isCapacityTagClosed(tag: CapacityTagDto, closedFlags: CapacityClosedFlags): boolean {
	const applicable: boolean[] = [];
	if (tag.showForVehicleBookings) {
		applicable.push(closedFlags.vehicleBookingsClosed);
	}
	if (tag.showForPassengerBookings) {
		applicable.push(closedFlags.passengerBookingsClosed);
	}
	if (tag.showForFreightBookings) {
		applicable.push(closedFlags.freightBookingsClosed);
	}

	return applicable.length > 0 && applicable.every(Boolean);
}
